import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import QueryString from 'query-string';
const projectReviewCompletionsService = {
  all(companyId, businessUnits, subsidiary_company_ids, years) {
    const query = QueryString.stringify({
      business_units: businessUnits,
      subsidiary_company_ids: subsidiary_company_ids,
      years: years
    }, {
      arrayFormat: 'comma'
    });
    return fetch("/api/companies/".concat(companyId, "/project_review_completions?").concat(query), request.get);
  }
};
export default projectReviewCompletionsService;